/**
 * SPRINT V4 — Hub mounted inside HomeFeedDrawer.
 * Bundles: contextual push preview, cinematic reel, cliffhanger card.
 * Splash + premium goal celebration mount globally via RetentionFab.
 */
import { useMemo } from "react";
import { Bell, Film, Hourglass } from "lucide-react";
import { useSelectedNation } from "@/hooks/useSelectedNation";
import {
  dispatchContextualPush,
  recordPushOpened,
  recordPushConverted,
  type PushContextMessage,
} from "@/lib/v4/contextualPush";
import { CinematicMomentsReel } from "./CinematicMomentsReel";
import { CliffhangerCard } from "./CliffhangerCard";

export function SprintV4Hub() {
  const { nation } = useSelectedNation();

  const preview = useMemo<PushContextMessage | null>(() => {
    return dispatchContextualPush(
      {
        nationCode: nation,
        previousRank: 3,
        currentRank: 4,
        rivalNationCode: nation === "MEX" ? "ARG" : "MEX",
        rivalGapPoints: 214,
        livePredictionMatchId: null,
        claimWindowMinutesLeft: null,
        rivalJustOvertook: false,
      },
      { force: true },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nation]);

  return (
    <div className="space-y-3 rounded-2xl border border-primary/30 bg-gradient-to-br from-primary/10 via-background/40 to-background/40 p-3">
      <div className="flex items-center gap-2 text-xs font-black uppercase tracking-[0.18em] text-primary">
        <Bell className="h-3.5 w-3.5" /> Sprint V4 · Adicción
      </div>

      {preview && (
        <div
          onClick={() => { recordPushOpened(preview); recordPushConverted(preview); }}
          className="cursor-pointer rounded-xl border border-[oklch(0.78_0.2_60)]/40 bg-[oklch(0.78_0.2_60)]/10 p-3"
        >
          <div className="text-[11px] font-bold">{preview.title}</div>
          <div className="text-[10px] text-muted-foreground">{preview.body}</div>
          <div className="mt-1 text-[9px] uppercase tracking-widest text-primary">Push contextual</div>
        </div>
      )}

      <div>
        <div className="mb-1 flex items-center gap-1.5 text-[11px] font-bold"><Film className="h-3 w-3 text-primary" /> Momentos cinemáticos</div>
        <CinematicMomentsReel />
      </div>

      <div>
        <div className="mb-1 flex items-center gap-1.5 text-[11px] font-bold"><Hourglass className="h-3 w-3 text-primary" /> Cliffhanger</div>
        <CliffhangerCard />
      </div>
    </div>
  );
}